import { call, put, select, takeEvery } from 'typed-redux-saga';

import { navigateAction } from '../../../helpers/navigation/slice';
import { selectIsCrosspageNotification } from './selectors';
import {
    closeConfirmNotificationAction,
    openConfirmNotificationAction,
    resetConfirmNotificationData,
    setConfirmNotificationData,
} from './slice';

function* openConfirmNotificationSaga({ payload }: ReturnType<typeof openConfirmNotificationAction>) {
    if (!payload || !payload.headerText || !payload.contentText) {
        return;
    }

    yield* put(setConfirmNotificationData(payload));
}

function* closeConfirmNotificationSaga() {
    yield* put(resetConfirmNotificationData());
}

function* closeConfirmNotificationByNavigateSaga() {
    if (yield* select(selectIsCrosspageNotification)) {
        return;
    }

    yield* call(closeConfirmNotificationSaga);
}

export const confirmNotificationSaga = function* () {
    yield* takeEvery(openConfirmNotificationAction, openConfirmNotificationSaga);
    yield* takeEvery(closeConfirmNotificationAction, closeConfirmNotificationSaga);
    yield* takeEvery(navigateAction, closeConfirmNotificationByNavigateSaga);
};
